import { PlateEditor, Value } from '@udecode/plate-common';
import { flashActionsInput } from 'features/plate/customPlugins/queries/findFlashActionsInput';

export const isSelectionInFlashActionsInput = <V extends Value>(editor: PlateEditor<V>) =>
  flashActionsInput(editor) !== undefined;
